import React from "react";
import "./Video.css";

const Video = () => {
  return (
    <div className="video">
      <div className="video1">
        <h2>Video</h2>
      </div>
    </div>
  );
};

export default Video;
